var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _path13, _rect5, _rect6, _path14, _path15, _rect7, _rect8, _ellipse3, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 210,
    viewBox: "0 0 244 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.759 104C163.759 138.794 133.538 167 96.2588 167C58.9796 167 28.7588 138.794 28.7588 104C28.7588 69.2061 58.9796 41 96.2588 41C133.538 41 163.759 69.2061 163.759 104Z",
    fill: "url(#paint0_linear_1641_922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7588 27H100.759V43H90.7588V27Z",
    fill: "url(#paint1_linear_1641_922)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.7588,
    cy: 15,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7588 172C136.523 172 168.759 142.003 168.759 105C168.759 82.6269 156.974 62.8153 138.867 50.6465C137.185 49.5166 135.187 48.9736 133.161 48.9736H60.3566C58.3308 48.9736 56.3322 49.5166 54.6508 50.6465C36.5431 62.8153 24.7588 82.6269 24.7588 105C24.7588 142.003 56.9943 172 96.7588 172Z",
    fill: "url(#paint2_linear_1641_922)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5209,
    cy: 147.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 45.5209 147.972)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.618 157.846C59.3312 155.093 57.0658 148.461 51.5579 143.034C46.0501 137.608 39.3856 135.441 36.6723 138.195C33.959 140.949 36.2245 147.581 41.7323 153.007C47.2402 158.434 53.9047 160.6 56.618 157.846ZM51.8861 154.316C53.6126 152.563 52.1711 148.344 48.6665 144.891C45.1619 141.438 40.9213 140.059 39.1949 141.812C37.4685 143.564 38.91 147.784 42.4146 151.237C45.9191 154.689 50.1597 156.068 51.8861 154.316Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.716 150.302L52.8088 146.373L44.9514 140.187L41.8586 144.116L49.716 150.302ZM33 155.5L33.9806 160.403L33 155.5ZM22.4224 144.876C21.1339 142.434 18.1095 141.498 15.6671 142.787C13.2247 144.075 12.2892 147.099 13.5776 149.542L22.4224 144.876ZM41.8586 144.116C39.1125 147.604 37.098 148.99 35.8262 149.611C34.4705 150.272 33.7997 150.241 32.0194 150.597L33.9806 160.403C34.7003 160.259 37.3398 159.999 40.2111 158.598C43.1664 157.156 46.2955 154.647 49.716 150.302L41.8586 144.116ZM32.0194 150.597C32.2702 150.547 31.9334 150.653 30.7692 150.292C29.7477 149.975 28.5104 149.43 27.2383 148.713C25.9727 148 24.7967 147.187 23.8773 146.405C23.4203 146.017 23.063 145.666 22.8025 145.372C22.6741 145.227 22.5803 145.108 22.5148 145.017C22.4826 144.972 22.4595 144.937 22.444 144.912C22.4283 144.887 22.422 144.875 22.4224 144.876L13.5776 149.542C14.5094 151.308 16.0034 152.836 17.3982 154.022C18.868 155.273 20.5839 156.442 22.3296 157.426C24.0689 158.406 25.9622 159.271 27.8073 159.843C29.5096 160.371 31.7751 160.844 33.9806 160.403L32.0194 150.597Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6782 150.349L52.818 146.457L45.0357 140.178L41.8958 144.069L49.6782 150.349ZM36 155L34.2913 150.301L36 155ZM23.1154 143.077C22.0533 140.528 19.1259 139.323 16.5769 140.385C14.0279 141.447 12.8225 144.374 13.8846 146.923L23.1154 143.077ZM13.8846 146.923C14.1383 147.532 14.4307 148.119 14.7508 148.682L23.4427 143.737C23.306 143.497 23.1983 143.276 23.1154 143.077L13.8846 146.923ZM35.3792 160.272C36.1516 160.165 36.9345 159.98 37.7087 159.699L34.2913 150.301C34.2357 150.321 34.1433 150.348 34.0043 150.367L35.3792 160.272ZM37.7087 159.699C37.9542 159.61 38.1824 159.529 38.3951 159.456L35.1415 150C34.8754 150.092 34.5926 150.191 34.2913 150.301L37.7087 159.699ZM49.1775 150.971C49.3379 150.771 49.5047 150.564 49.6782 150.349L41.8958 144.069C41.7163 144.291 41.5438 144.506 41.3779 144.712L49.1775 150.971Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2076 149.209C55.1456 147.155 53.5676 145.014 51.5579 143.034C48.4413 139.964 44.9543 137.937 42.0224 137.255L43.2595 141.398C44.9746 141.955 46.9127 143.163 48.6665 144.891C50.0727 146.276 51.1468 147.785 51.8173 149.209H56.2076Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5557,
    cy: 138.555,
    r: 10.625,
    transform: "rotate(-30.6263 14.5557 138.555)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 157.765 144.694)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.906 157.846C133.193 155.093 135.459 148.461 140.966 143.034C146.474 137.608 153.139 135.441 155.852 138.195C158.565 140.949 156.3 147.581 150.792 153.007C145.284 158.434 138.62 160.6 135.906 157.846ZM140.638 154.316C138.912 152.563 140.353 148.344 143.858 144.891C147.363 141.438 151.603 140.059 153.33 141.812C155.056 143.564 153.614 147.784 150.11 151.237C146.605 154.689 142.365 156.068 140.638 154.316Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.808 150.302L139.715 146.373L147.573 140.187L150.665 144.116L142.808 150.302ZM161.501 162.709L165.974 160.475L161.501 162.709ZM177.857 178.142C175.293 179.168 172.383 177.921 171.358 175.357C170.332 172.793 171.579 169.883 174.143 168.858L177.857 178.142ZM150.665 144.116C153.386 147.573 155.94 149.64 158.53 151.823C161.087 153.978 163.972 156.466 165.974 160.475L157.027 164.943C156.033 162.951 154.62 161.606 152.085 159.469C149.584 157.361 146.254 154.679 142.808 150.302L150.665 144.116ZM165.974 160.475C166.353 161.235 167.161 162.157 168.551 163.177C169.911 164.175 171.534 165.057 173.181 165.856C174.495 166.493 176.623 167.431 177.615 167.955C177.933 168.123 178.32 168.339 178.699 168.596C178.997 168.799 179.683 169.283 180.263 170.07C180.897 170.931 181.968 173.049 180.782 175.482C179.888 177.315 178.266 177.979 177.857 178.142L174.143 168.858C174.046 168.896 172.612 169.421 171.793 171.1C170.683 173.378 171.716 175.328 172.213 176.002C172.465 176.344 172.703 176.564 172.823 176.668C172.953 176.781 173.049 176.848 173.081 176.869C173.136 176.907 173.113 176.886 172.946 176.798C172 176.299 171.003 175.914 168.817 174.853C166.962 173.954 164.711 172.763 162.633 171.238C160.586 169.735 158.396 167.683 157.027 164.943L165.974 160.475Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.808 150.302L139.715 146.373L147.572 140.187L150.665 144.116L142.808 150.302ZM160.5 161L164.973 158.766L160.5 161ZM178.506 179.768C175.872 180.599 173.064 179.139 172.232 176.506C171.401 173.872 172.861 171.064 175.494 170.232L178.506 179.768ZM175.494 170.232C175.669 170.177 175.79 170.132 175.868 170.1L179.66 179.353C179.284 179.507 178.897 179.644 178.506 179.768L175.494 170.232ZM169.741 172.904C169.265 172.679 168.767 172.445 168.268 172.208L172.559 163.175C173.044 163.406 173.525 163.632 174.011 163.862L169.741 172.904ZM156.927 164.681C156.605 164.252 156.295 163.771 156.027 163.235L164.973 158.766C164.933 158.686 164.909 158.658 164.926 158.68L156.927 164.681ZM156.027 163.235C155.895 162.97 155.763 162.732 155.632 162.514L164.186 157.336C164.462 157.791 164.724 158.267 164.973 158.766L156.027 163.235ZM143.683 151.379C143.393 151.033 143.101 150.675 142.808 150.302L150.665 144.116C150.895 144.408 151.121 144.686 151.343 144.95L143.683 151.379Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.317 149.209C137.379 147.155 138.957 145.014 140.966 143.034C144.083 139.964 147.57 137.937 150.502 137.255L149.265 141.398C147.55 141.955 145.612 143.163 143.858 144.891C142.452 146.276 141.378 147.785 140.707 149.209H136.317Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.556,
    cy: 172.555,
    r: 10.625,
    transform: "rotate(-30.6263 170.556 172.555)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.7588,
    y: 145,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.759,
    y: 145,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2588,
    y: 142,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 67,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106 94C106 92.6868 105.741 91.3864 105.239 90.1732C104.736 88.9599 104 87.8575 103.071 86.9289C102.142 86.0003 101.04 85.2638 99.8268 84.7612C98.6136 84.2587 97.3132 84 96 84C94.6868 84 93.3864 84.2587 92.1732 84.7612C90.9599 85.2638 89.8575 86.0003 88.9289 86.9289C88.0003 87.8575 87.2638 88.9599 86.7612 90.1732C86.2587 91.3864 86 92.6868 86 94",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156 94C156 92.6868 155.741 91.3864 155.239 90.1732C154.736 88.9599 154 87.8575 153.071 86.9289C152.142 86.0003 151.04 85.2638 149.827 84.7612C148.614 84.2587 147.313 84 146 84C144.687 84 143.386 84.2587 142.173 84.7612C140.96 85.2638 139.858 86.0003 138.929 86.9289C138 87.8575 137.264 88.9599 136.761 90.1732C136.259 91.3864 136 92.6868 136 94",
    stroke: "#72B2FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8359,
    y: 103.559,
    width: 7.25925,
    height: 58.2675,
    transform: "rotate(18.7474 18.8359 103.559)",
    fill: "#DCAF85"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2529,
    y: 105.397,
    width: 1.53762,
    height: 58.2675,
    transform: "rotate(18.7474 24.2529 105.397)",
    fill: "#C7976B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58496 100.671L34.9485 110.009L39.0004 98.6698C36.074 97.7805 28.0602 95.2015 19.4161 92C17.255 98.4031 10.862 97.7805 7.9356 96.6689L6.58496 100.671Z",
    fill: "#373737"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98.5L35 110L31 108.5L35 97.5L39 98.5Z",
    fill: "#242424"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154.416,
    y: 186.447,
    width: 97,
    height: 40,
    transform: "rotate(-54.5077 154.416 186.447)",
    fill: "#DCAF84"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 196.29,
    y: 140.444,
    width: 16,
    height: 1,
    transform: "rotate(12.9484 196.29 140.444)",
    fill: "#515151"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.69,
    cy: 140.819,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(12.9484 195.69 140.819)",
    fill: "#6A6A6A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 182.988,
    y: 206.822,
    width: 97,
    height: 4.907,
    transform: "rotate(-54.5077 182.988 206.822)",
    fill: "#D2A171"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1641_922",
    x1: 96.2588,
    y1: 27,
    x2: 96.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1641_922",
    x1: 96.2588,
    y1: 27,
    x2: 96.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1641_922",
    x1: 96.7588,
    y1: 37.9999,
    x2: 96.7588,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder);
export default __webpack_public_path__ + "static/media/builder.e6ceef28f70bcc110cb72007de4474f7.svg";
export { ForwardRef as ReactComponent };